(function (Drupal, once) {

  Drupal.behaviors.vlizAccordeon = {

    attach(context, settings) {

      const accordeonItems = once('.vliz-accordeon-item', '.vliz-accordeon .views-row');

      accordeonItems.forEach((item) => {
          item.addEventListener('click', (e) => {

            accordeonItems.forEach((subItem) => {
              if (subItem !== item) {
                subItem.classList.remove('active');
              }
            });

            if (item.classList.contains('active')) {
              item.classList.remove('active');
            } else {
              item.classList.add('active');
              // item.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }
          });
      });

    }
  }


}(Drupal, once));
